import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { getBillingAccount, selectBillingAccount, selectEtf } from '@app/redux';

import MultilineLoading from '../MultilineLoading';

import styles from './index.module.scss';

const EarlyTerminationFee = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Disconnect');

  const {
    data: { remainingMonthsInContract: remainingMonths, totalMonthsInContract: totalMonths, calculatedEtf } = {},
    loading,
    error,
  } = useSelector(selectEtf);
  const totalEtf = calculatedEtf?.value;

  const billingAccount = useSelector(selectBillingAccount);

  useEffect(() => {
    if (!billingAccount.dueDate) dispatch(getBillingAccount());
  }, [dispatch, billingAccount.dueDate]);

  const dueDate = billingAccount?.dueDate ? format(billingAccount?.dueDate, 'MMM dd') : '';

  return (
    <div>
      <Txt variant="heading6" mb="16px" mt="24px">
        {t('cart.etf.heading')}
      </Txt>
      {loading || billingAccount.loading ? (
        <MultilineLoading lines={5} />
      ) : (
        <>
          <Txt variant="tinyRegular" color="subtle">
            {error
              ? t('cart.etf.descriptionError')
              : t('cart.etf.description', {
                  remainingMonths,
                  totalMonths,
                  dueDate,
                })}
          </Txt>
          {Boolean(totalEtf) && (
            <>
              <div className={styles['etfFee']}>
                <Txt variant="bodySmallRegular" color="subtle">
                  {t('cart.etfFee')}
                </Txt>
                <Txt variant="smallBold" color="subtle">
                  ${totalEtf}
                </Txt>
              </div>
              <div className={styles['etfSummary']}>
                <Txt variant="paragraphBold" mt="16px">
                  ${totalEtf}
                </Txt>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default EarlyTerminationFee;
